var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.shouldShowProfile ? _c('div', {
    staticClass: "py-3"
  }, _vm._l(_vm.profile.customer_profile, function (group, idx) {
    return _c('div', {
      key: idx,
      staticClass: "detail mb-3"
    }, [_c('div', {
      staticClass: "detail__wrapper"
    }, _vm._l(group.member_fields, function (field, index2) {
      return _c('div', {
        key: 'field' + index2,
        staticClass: "detail__item full"
      }, [_c('div', {
        staticClass: "detail__title"
      }, [_vm._v(_vm._s(field.title))]), _c('div', {
        staticClass: "detail__value"
      }, [_vm._v(" " + _vm._s(_vm.getFieldDisplayValue(field)) + " ")])]);
    }), 0)]);
  }), 0) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }